// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import type { SchemaMigration } from '../types'

/**
 * Baseline migration for contentpieces.
 * Establishes version 1 as the starting point for migration tracking.
 * No data changes — existing records are already at this schema version.
 */
export const migration: SchemaMigration = {
  schema: 'contentpieces',
  version: 1,
  description: 'Establish baseline for contentpieces schema',
  schemaChanges: schema => ({
    ...schema,
    version: 1,
  }),
}
